import plausibleTracker, { EventOptions } from 'plausible-tracker';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const plausible =
  typeof window !== 'undefined'
    ? plausibleTracker({
        domain: 'backstage.dev.wsa.com',
        trackLocalhost: false,
        apiHost: 'https://dev-euw-plausible.westeurope.cloudapp.azure.com',
      })
    : null;

export const PlausibleProvider = () => {
  const location = useLocation();

  useEffect(() => {
    plausible?.trackPageview();
  }, [location]);

  useEffect(() => {
    plausible?.enableAutoOutboundTracking();
  }, []);

  return null;
};

export function trackPlausibleEvent(eventName: string, props: Record<string, string>) {
  plausible?.trackEvent(eventName, { props });
}

export type { EventOptions };
